import { apiFetchBaseQuery } from "@/redux/apiFetchBaseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";
import {
	GetChartsResponse,
	GetOrdersResponse,
	GetChartsParams,
	GetOrdersParams,
	GetCardsResponse,
} from "@/types/UserDashboard";
import { DefaultApiSuccessResponse } from "@/types/ApiResponse";

const TIMEOUT = 3 * 60 * 1000; // 3 minutes

export const userDashboardSlice = createApi({
	reducerPath: "userDashboardSlice",
	baseQuery: apiFetchBaseQuery,
	tagTypes: ["charts", "charts_with_date_range", "orders", "cards", "goldenTicket"],
	keepUnusedDataFor: 0, // Set cache time to 0 seconds
	endpoints: builder => ({
		getOrders: builder.query<GetOrdersResponse, GetOrdersParams>({
			query: ({ status, pageNo, pageSize }) => ({
				url: `user/dashboard/orders/${status}?page_no=${pageNo}&limit=${pageSize}`,
				timeout: TIMEOUT,
			}),
			providesTags: ["orders"],
			keepUnusedDataFor: 0, // cache time in seconds
		}),
		getCards: builder.query<GetCardsResponse, undefined>({
			query: () => ({
				url: "user/dashboard/cards",
				timeout: TIMEOUT,
			}),
			providesTags: ["cards"],
			keepUnusedDataFor: 0, // cache time in seconds
		}),
		getChartsWithDateRange: builder.query<GetChartsResponse, GetChartsParams>({
			query: ({ startDate, endDate }) => ({
				url: `user/dashboard/charts/${startDate}/${endDate}`,
				timeout: TIMEOUT,
			}),
			providesTags: ["charts_with_date_range"],
			keepUnusedDataFor: 0, // cache time in seconds
		}),
		getChartsStat: builder.query<GetChartsResponse, null>({
			query: () => ({
				url: `user/dashboard/charts/stats`,
				timeout: TIMEOUT,
			}),
			providesTags: ["charts"],
			keepUnusedDataFor: 0, // cache time in seconds
		}),
		getGoldenTicket: builder.query<DefaultApiSuccessResponse, { agencyId: number }>({
			query: ({ agencyId }) => ({
				url: `agency/golden-ticket/${agencyId}`,
				timeout: TIMEOUT,
			}),
			providesTags: ["goldenTicket"],
			// keepUnusedDataFor: 0, // cache time in seconds
		}),
	}),
});

export const {
	useGetOrdersQuery,
	useGetCardsQuery,
	useGetChartsWithDateRangeQuery,
	useGetChartsStatQuery,
	useGetGoldenTicketQuery,
	useLazyGetGoldenTicketQuery,
} = userDashboardSlice;
